import { MetricService } from "../../services/metricService";
import { GtmhubController } from "@gtmhub/core";
import { IComponentOptions, IRootScopeService } from "angular";
import { IModalService } from "angular-ui-bootstrap";
import { IModalComponent } from "@gtmhub/core/routing";
import { UIErrorHandlingService } from "@gtmhub/error-handling";
import { OkrEvents } from "@gtmhub/okrs";

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DisableMetricSyncBindings extends IModalComponent<{ metricId: string }> {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface DisableMetricSyncCtrl extends DisableMetricSyncBindings {}
export class DisableMetricSyncCtrl extends GtmhubController {
  static $inject = ["$rootScope", "MetricService", "UIErrorHandlingService"];
  private okrEvents: OkrEvents;

  constructor(private $rootScope: IRootScopeService, private metricService: MetricService, private uiErrorHandlingService: UIErrorHandlingService) {
    super();
    this.okrEvents = new OkrEvents(this.$rootScope);
  }

  disableSync(): void {
    this.metricService
      .patchMetric({ id: this.resolve.metricId, sourceMetricId: "" })
      .then((metric) => {
        this.okrEvents.broadcastGoalsChanged("metricUpdated", {
          metric,
        });

        this.close();
      })
      .catch((err) => this.uiErrorHandlingService.handleModal(err));
  }
}

export class DisableMetricSyncModal {
  static $inject = ["$uibModal"];

  constructor(private $uibModal: IModalService) {}

  open(metricId: string): void {
    this.$uibModal.open({
      component: "disableMetricSync",
      resolve: {
        metricId: () => metricId,
      },
      windowClass: "medium disable-sync",
      backdrop: true,
    });
  }
}

export const DisableMetricSyncComponent: IComponentOptions = {
  controller: DisableMetricSyncCtrl,
  templateUrl: require("./disable-metric-sync.jade"),
  bindings: {
    resolve: "<",
    close: "&",
    dismiss: "&",
  },
};
